export interface LogoHeader {
  pageHeader: {
    altText: string;
    logoUrl: string;
  };
}
